import conf from '../../conf';
import fetch from '../fetch';

import type { Dispatch } from '@avalara/types/actions';
import type { NewAccountForm } from '@avalara/types/index';
import type { CybersourceFormData } from '../../../../types/cybersource';

export const getCybersourceFormData =
  (currency: string, signupData: NewAccountForm, setFormData: (_: CybersourceFormData) => void) =>
  async (dispatch: Dispatch): Promise<void> => {
    const res = await fetch(dispatch)<CybersourceFormData>(
      `${conf.API_URL}/api/cybersource/signature?currency=${currency}`,
      {
        method: 'POST',
        body: JSON.stringify(signupData),
      },
    );

    // TODO - add error handling for this failure:
    if (!res.ok) return;

    setFormData(res.value);
  };
